import { useEffect, useState, useRef } from "react";
import { useInView } from "framer-motion";
import "../../styles/code/StatsSection.css";

const stats = [
  { label: "Doanh nghiệp đối tác", suffix: "+", target: 300 },
  { label: "Học viên có việc làm sau khi tốt nghiệp", suffix: "%", target: 98 },
  { label: "Cơ sở trên toàn quốc", suffix: "+", target: 40 },
  { label: "Học viên đã tốt nghiệp", suffix: "+", target: 15000 },
];

function StatsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  const [counts, setCounts] = useState(stats.map(() => 0));

  useEffect(() => {
    if (!isInView) return;

    const durations = stats.map(() => 2000); // 2s mỗi stat
    const intervals = stats.map((stat, i) => {
      const increment = stat.target / (durations[i] / 30);
      return setInterval(() => {
        setCounts((prev) => {
          const updated = [...prev];
          updated[i] = Math.min(prev[i] + increment, stat.target);
          return updated;
        });
      }, 30);
    });

    return () => intervals.forEach(clearInterval);
  }, [isInView]);

  return (
    <div className="wrapper-stats-session">
      <section className="stats-section">
        <div className="stats-image">
          <img
            src="/images/code/partner.webp"
            alt="Stats"
          />
        </div>
        {/* Đặt ref vào phần cần theo dõi scroll */}
        <div
          className="stats-content"
          ref={ref}
        >
          {stats.map((stat, index) => (
            <div
              className="stat-item"
              key={index}
            >
              <div className="stat-number">
                {Math.floor(counts[index])}
                {stat.suffix}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default StatsSection;
